import { Component } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-admin-contact-info',
  templateUrl: './admin-contact-info.component.html',
  styleUrls: ['./admin-contact-info.component.css'],
  providers: [ConfirmationService]
})
export class AdminContactInfoComponent {

}
